export default __webpack_public_path__ + "static/media/Selectimage.2cb5d3e1.svg";